module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-537.49b5249.woff2";